package com.essntl.features.currency.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [CurrencySupabaseDataSource::class])
class CurrencySupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<CurrencyDto> {
    override val tableName: String = "currency"
}
